import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import {} from "../../../Globals/styles";

class EmployeeDragable extends Component {
  render() {
    return (
      <div onClick={this.props.onClick} style={styles.dragable}>
        <i className="fa fa-times-circle" />
      </div>
    );
  }
}

var styles = {
  dragable: {
    position: "absolute",
    left: "0",
    height: "40px",
    width: "40px",
    textAlign: "center",
    lineHeight: "40px",
  },
};

EmployeeDragable.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    absence: PropTypes.shape({
      date: PropTypes.object.isRequired,
      hours: PropTypes.number.isRequired,
      absenceCode: PropTypes.string,
    }),
    timeRegistrations: PropTypes.arrayOf(
      PropTypes.shape({
        hours: PropTypes.number.isRequired,
        nightHours: PropTypes.number.isRequired,
        employeeFunction: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  getButtonContent: PropTypes.func.isRequired,
  setEmployeeIsDragging: PropTypes.func.isRequired,
};
export default Radium(EmployeeDragable);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/employeeDragable.jsx